var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('worker-new',{attrs:{"edit":true,"worker":_vm.worker},on:{"close":_vm.close,"editWorker":function($event){return _vm.$emit('editWorker')},"workerDeleted":_vm.workerDeleted}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }